module.exports = __webpack_public_path__ + "Flag-690.ed82ee9c9614a7cb5a3582d14cef1b94.svg";